import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Find me on : `}<a href="https://github.com/VanshVarshney" target="_blank">{` Github `}</a>{` & `}<a href="https://www.linkedin.com/in/vanshvarshney/" target="_blank">{` LinkedIn `}</a></p>
    <p>{`You Can Also Follow Me On Other Social Handles : `}<a href="https://www.instagram.com/VanshVarshney_/" target="_blank">{` Instagram `}</a>{` , `}<a href="https://twitter.com/VanshVarshney_" target="_blank">{` Twitter `}</a>{` & `}<a href="https://www.facebook.com/vanshvarshney24/" target="_blank">{` Facebook `}</a></p>
    <p>{`Mail Box : `}<a href="mailto: vanshvarsh@gmail.com" target="_blank">{` Vansh Varshney `}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      